var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Button } from '../Button';
import { Icon } from '../Icon';
export const Banner = (_a) => {
    var { primaryActionName, secondaryActionName, children, className, onPrimaryActionClick, onSecondaryActionClick, onClose, icon, status = 'info', title } = _a, props = __rest(_a, ["primaryActionName", "secondaryActionName", "children", "className", "onPrimaryActionClick", "onSecondaryActionClick", "onClose", "icon", "status", "title"]);
    const getIconType = () => {
        switch (status) {
            case 'critical':
                return 'warning';
            case 'warning':
                return 'warning';
            case 'success':
                return 'check_circle';
            default:
                return 'info';
        }
    };
    const hasPrimaryAction = () => {
        return !!(primaryActionName && onPrimaryActionClick);
    };
    const hasSecondaryAction = () => {
        return !!(secondaryActionName && onSecondaryActionClick);
    };
    const BannerClasses = classnames('Banner', className, {
        'Banner--critical': status === 'critical',
        'Banner--warning': status === 'warning',
        'Banner--success': status === 'success',
        'Banner--info': status === 'info',
        'Banner--compact': children === undefined,
    });
    return (React.createElement("div", Object.assign({ className: BannerClasses, "data-anvil-component": "Banner" }, props),
        icon && React.createElement(Icon, { className: "Banner__icon", name: getIconType() }),
        React.createElement("div", { className: "Banner__body" },
            React.createElement("div", { className: "Banner__text" },
                React.createElement("div", { className: "Banner__title" }, title),
                children),
            (primaryActionName || secondaryActionName) && (React.createElement("div", { className: "Banner__action" },
                hasPrimaryAction() && (React.createElement(Button, { outline: true, small: true, onClick: onPrimaryActionClick }, primaryActionName)),
                hasSecondaryAction() && (React.createElement(Button, { fill: "subtle", small: true, onClick: onSecondaryActionClick }, secondaryActionName))))),
        onClose && (React.createElement(Icon, { "aria-label": "close banner", className: "Banner__close", onClick: onClose, name: "clear" }))));
};
//# sourceMappingURL=Banner.js.map